import React from "react";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend
} from "recharts";

const renderLabel = (data, key, isPercent = false) => props => {
  const { x, y, width, height, index } = props;

  const value =
    data && data[index] && data[index][key] != null ? data[index][key] : null;

  if (!value || value < 3 || height < 5) return null;

  const text = isPercent
    ? (value > 1 ? value : value * 100).toFixed(1) + "%"
    : value;

  return (
    <text
      x={x + width / 2}
      y={y + height / 2}
      fill="#fff"
      fontSize={10}
      textAnchor="middle"
      dominantBaseline="middle"
      fontWeight={"bold"}
    >
      {text}
    </text>
  );
};

const StackBarchart = prop => {
  return (
    <ResponsiveContainer width="100%" height={290}>
      <BarChart
        data={prop.dataStackBar}
        margin={{ top: 15, right: 30, left: 10, bottom: 5 }}
      >
        <CartesianGrid strokeDasharray="3 3" />

        <XAxis dataKey="name" />

        <YAxis />

        {prop.order === "stack7_1_15" &&
          <Tooltip
            formatter={(value, name) => [`${value} เรื่อง`, name.toUpperCase()]}
          />}

        {prop.order === "stack7_1_16" &&
          <Tooltip
            formatter={(value, name) => [`ร้อยละ ${value}`, name.toUpperCase()]}
          />}

        {prop.order === "stack7_1_17" &&
          <Tooltip
            formatter={(value, name) => [`${value} เรื่อง`, name.toUpperCase()]}
          />}

        {prop.order === "stack7_1_18" &&
          <Tooltip
            formatter={(value, name) => [`ร้อยละ ${value}`, name.toUpperCase()]}
          />}

        <Legend />

        {prop.order === "stack7_1_15" &&
          <React.Fragment>
            <Bar
              dataKey="been"
              name="BEEN"
              stackId="a"
              fill="#5D8736"
              label={renderLabel(prop.dataStackBar, "been")}
            />
            <Bar
              dataKey="hiv"
              name="HIV"
              stackId="a"
              fill="#809D3C"
              label={renderLabel(prop.dataStackBar, "hiv")}
            />
            <Bar
              dataKey="other"
              name="OTHER"
              stackId="a"
              fill="#A9C46C"
              label={renderLabel(prop.dataStackBar, "other")}
              radius={[8, 8, 0, 0]}
            />
          </React.Fragment>}

        {prop.order === "stack7_1_16" &&
          <React.Fragment>
            <Bar
              dataKey="been"
              name="BEEN"
              stackId="a"
              fill="#261CC1"
              label={renderLabel(prop.dataStackBar, "been", true)}
            />
            <Bar
              dataKey="hiv"
              name="HIV"
              stackId="a"
              fill="#3A9AFF"
              label={renderLabel(prop.dataStackBar, "hiv", true)}
            />
            <Bar
              dataKey="other"
              name="OTHER"
              stackId="a"
              fill="#FF8C00"
              label={renderLabel(prop.dataStackBar, "other", true)}
              radius={[8, 8, 0, 0]}
            />
          </React.Fragment>}

        {prop.order === "stack7_1_17" &&
          <React.Fragment>
            <Bar
              dataKey="nolocal"
              name="โครงการต่างประเทศ"
              stackId="a"
              fill="#547792"
              label={renderLabel(prop.dataStackBar, "nolocal")}
            />
            <Bar
              dataKey="local"
              name="โครงการในประเทศ"
              stackId="a"
              fill="#FAB95B"
              label={renderLabel(prop.dataStackBar, "local")}
              radius={[8, 8, 0, 0]}
            />
          </React.Fragment>}

        {prop.order === "stack7_1_18" &&
          <React.Fragment>
            <Bar
              dataKey="nolocal"
              name="โครงการต่างประเทศ"
              stackId="a"
              fill="#DA3D20"
              label={renderLabel(prop.dataStackBar, "nolocal", true)}
            />
            <Bar
              dataKey="local"
              name="โครงการในประเทศ"
              stackId="a"
              fill="#3D45AA"
              label={renderLabel(prop.dataStackBar, "local", true)}
              radius={[8, 8, 0, 0]}
            />
          </React.Fragment>}
      </BarChart>
    </ResponsiveContainer>
  );
};

export default StackBarchart;
